export async function resolveConfiguredOutputModel(
  modelStore,
  intentType,
  fallbackSlug,
  { force = true } = {},
) {
  const model = await modelStore.resolveDefaultOutputModel(
    intentType,
    fallbackSlug,
    { force },
  );
  const slug = model?.slug
    || modelStore.getDefaultOutputModelSlug?.(intentType, fallbackSlug)
    || fallbackSlug;

  return { model, slug };
}
